import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useUserState = () => React.useContext(Context)
export const useUser = () => useUserState()?.user

const QUERY = gql`
  query User($id: ID) {
    user(id: $id, filter: { includeDisabled: true, ignoreSegments: true }) {
      id
      name
      email
      insertedAt
      canAccessPaymentModule
      isFakeEmail
      contract {
        id
        relatedUsers
        workShifts
        relatedUsers
        group {
          id
          name
        }
        groups {
          id
          name
        }
        profile {
          id
          name
          label
        }
        fieldValues {
          id
          value
          fieldId
          field {
            id
            type
            name
          }
        }
      }
    }
  }
`

const UsersLoader = ({ children }) => {
  const { id } = useModalData() || {}
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: accountsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UsersLoader
